import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

(()=>{
	if(document.getElementById('wadm-otpl-main')===null)return;
	const root=ReactDOM.createRoot(document.getElementById('wadm-otpl-main'));
	root.render(<App />);
})();

/*
<App>
	<div>
		<FlipField>
			<div>
				<div>
					<h3 />
					<a />
				</div>
				<div>
					<Tabs>
						<div>
							<div>
								<a />
							</div>
						</div>
						<InputBlock>
							<InputField />
						</InputBlock>
					</Tabs>
					<AfterTabs />
				</div>
			</div>
		</FlipField>
	</div>
</App>
 */